import React, { useState } from "react";
import InputField from "../../../../components/common/InputField";
import CustomButton from "../../../../components/common/CustomButton";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { message } from "antd";

const clearStoredAuthSession = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("userId");
  localStorage.removeItem("userDetails");
};

const LoginForm = () => {
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState("");
  const navigate = useNavigate();

  const handleChange = (value) => {
    // Allow only numeric input and restrict to a maximum of 10 digits
    if (/^\d*$/.test(value) && value.length <= 10) {
      setMobile(value);
      setError(""); // Clear error if input is valid
    } else {
      // Set error if the input is not numeric or exceeds 10 digits
      if (value.length > 10) {
        setError("Mobile number must be exactly 10 digits");
      } else {
        setError("Only numeric values are accepted");
      }
    }
  };

  const handleOtpRequest = async (e) => {
    e.preventDefault();
    // setError(''); // Clear previous errors

    // // Final validation before submission
    if (!mobile) {
      setError("Please enter 10 digit mobile number.");
      return; // Stop execution if mobile is not valid
    } else if (mobile.length !== 10) {
      setError("Mobile number must be exactly 10 digits");
      return; // Stop execution if mobile is not valid
    }


    try {
      clearStoredAuthSession();
      localStorage.setItem("mobileNumber", mobile);
      localStorage.setItem("lastOtpRequestedAt", Date.now().toString());
      // API call to request OTP with mobileNumber in the body
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/requestOTP`,
        { mobileNumber: mobile } // Mobile number passed in body
      );
      // console.log('OTP request response:', response.data);
      message.success(response?.data?.message || "OTP sent successfully to " + mobile);
      navigate(`/otpverify/${mobile}`);
      // Handle successful response here, e.g., navigate to another page
    } catch (error) {
      console.error("Error requesting OTP:", error);
      setError("Failed to request OTP. Please enter 10 digit mobile number.");
    }
    setLoading(false);
  };

  return (
    <>
      <form>
        <InputField
          type="text"
          value={mobile}
          onChange={handleChange}
          name="mobileNumber" // For reference
          placeholder="Enter your mobile number"
          error={typeof error === "string" ? error : ""}
          cssClass="mobile-input"
          maxLength={10} // Restrict input to 10 digits
          required
          className="input-default mb-3"
          autoComplete="off"
        // className="login-number"
        />
        <CustomButton
          type="primary"
          htmlType="submit"
          loading={loading}
          // style={{ width: "100%", marginTop: "10px" }}
          onClick={handleOtpRequest}
          className="login-button"
        >
      {loading ? "Requesting..." : "Request OTP"}
        </CustomButton>
      </form>
      <div style={{ marginTop: "12px", textAlign: "center" }}>
        <span>If not registered, </span>
        <span
          onClick={() => navigate("/registerNewUser")}
          style={{ color: "#1976d2", fontWeight: 500, cursor: "pointer" }}
        >
          please register
        </span>
      </div>
    </>
  );
};

export default LoginForm;
